'use client';
import styled from 'styled-components';

export const StyledDidYouKnowCard = styled.div`
  display: flex;
  flex-flow: column;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.background.lightest};
  padding: ${({ theme }) => theme.spacing(6)};
  ${({ theme }) => theme.fontFamily.base}
  max-width: none;
  width: 100%;

  @media ${({ theme }) => theme.tabletL} {
    max-width: 345px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  text-align: left;
  text-transform: uppercase;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const ImageContainer = styled.div`
  object-fit: fill;
  overflow: hidden;
  max-width: 80px;
  margin-right: ${({ theme }) => theme.spacing(2)};
  img {
    width: 100%;
  }
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.heading5}
  font-weight: bold;
`;

export const Explanation = styled.div`
  ${({ theme }) => theme.typography.body}
`;
